import type { FunctionComponent } from 'react';
import Badge from '../badge';
import type { StepInfo } from '../../../../../../services/types';

type ThumbnailProps = {
  asset: FunctionComponent;
  isLoadingCongrats: boolean;
  congratsClassName: string;
  step: StepInfo;
  shouldShowCongratsAnimation: boolean;
};

const Thumbnail: FunctionComponent<ThumbnailProps> = ({
  asset: Asset,
  isLoadingCongrats,
  congratsClassName,
  step,
  shouldShowCongratsAnimation,
}) => (
  <div className="thumbnail-congrats">
    <svg className={`thumbnail-${congratsClassName}`} viewBox="0 0 100 100">
      <circle className="bg" cx="50" cy="50" r="40" />
      <circle className="meter" cx="50" cy="50" r="40" />
    </svg>
    <div className="asset">
      <Asset />
    </div>
    {(!isLoadingCongrats || !shouldShowCongratsAnimation)
      ? <Badge shouldBeAnimated={shouldShowCongratsAnimation} stepStatus={step.status} />
      : null}
  </div>
);

export default Thumbnail;
